import {
  Card,
  CardHeader,
  CardBody,
  Form,
  Row,
  Col,
  FormGroup,
  Input,
} from "reactstrap";
import { Backdrop } from "components";
import { FiLoader } from "react-icons/fi";

const StaffDetails = ({ staff }) => {
  return (
    <Card className="bg-transparent">
      <Backdrop open={!staff} fitToParent={true}>
        <div className="text-center position-absolute">
          <FiLoader size={40} className="animate-spin" />
        </div>
      </Backdrop>
      <CardHeader>
        <h5 className="title">View Staff</h5>
      </CardHeader>
      <CardBody>
        <Form>
          <Row>
            <Col className="pr-md-1" md="3">
              <FormGroup>
                <label>Personnel ID</label>
                <Input
                  disabled
                  value={staff?.personnelId || ""}
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col className="px-md-1" md="3">
              <FormGroup>
                <label>Username</label>
                <Input
                  disabled
                  type="text"
                  className="text-light"
                  value={staff?.username || ""}
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="6">
              <FormGroup>
                <label>Email address</label>
                <Input
                  disabled
                  type="email"
                  className="text-light"
                  value={staff?.email || ""}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="pr-md-1" md="3">
              <FormGroup>
                <label>Birthday</label>
                <Input
                  value={staff?.birthday || ""}
                  className="text-light"
                  type="date"
                  disabled
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="3">
              <FormGroup>
                <label>RFID Number</label>
                <Input
                  value={staff?.rfidNumber || ""}
                  className="text-light"
                  type="text"
                  disabled
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="6">
              <FormGroup>
                <label>Official Start Date</label>
                <Input
                  value={staff?.officialStartDate}
                  disabled
                  className="text-light"
                  type="date"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="pr-md-1" md="6">
              <FormGroup>
                <label>Status</label>
                <Input
                  value={staff?.status || ""}
                  className="text-light"
                  type="text"
                  disabled
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="6">
              <FormGroup>
                <label>Region</label>
                <Input
                  value={staff?.region || ""}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="pr-md-1" md="4">
              <FormGroup>
                <label>Hourly Rate</label>
                <Input
                  value={staff?.hourlyRate || "None"}
                  className="text-light"
                  type="text"
                  disabled
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="4">
              <FormGroup>
                <label>Total Teaching Hours</label>
                <Input
                  value={Math.round(staff?.totalTeachingHours * 2) / 2 || 0}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="4">
              <FormGroup>
                <label>Total Training Hours</label>
                <Input
                  value={Math.round(staff?.totalTrainingHours * 2) / 2 || 0}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="pr-md-1" md="4">
              <FormGroup>
                <label>Total CL (Hours)</label>
                <Input
                  value={staff?.compensationLeaveHoursCount}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="4">
              <FormGroup>
                <label>Total CL Used (Hours)</label>
                <Input
                  value={staff?.compensationLeaveHoursUsed}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="4">
              <FormGroup>
                <label>Total CL Available (Hours)</label>
                <Input
                  value={
                    (staff?.compensationLeaveHoursCount ?? 0) -
                    (staff?.compensationLeaveHoursUsed ?? 0)
                  }
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="pr-md-1" md="4">
              <FormGroup>
                <label>Total AL Available (Days)</label>
                <Input
                  value={staff?.annualLeaveDaysCount}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="4">
              <FormGroup>
                <label>AL Used (Days)</label>
                <Input
                  value={staff?.annualLeaveDaysUsed}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col className="pl-md-1" md="4">
              <FormGroup>
                <label>AL Available (Days)</label>
                <Input
                  value={
                    (staff?.annualLeaveDaysCount ?? 0) -
                    (staff?.annualLeaveDaysUsed ?? 0)
                  }
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="pr-md-1" md="6">
              <FormGroup>
                <label>SL Taken (Hours)</label>
                <Input
                  value={staff?.sickLeaveDaysCount}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>

            <Col className="pl-md-1" md="6">
              <FormGroup>
                <label>NPL Taken (Hours)</label>
                <Input
                  value={staff?.unpaidLeaveDaysCount}
                  disabled
                  className="text-light"
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
};

export default StaffDetails;
